export const NW = 'NW';
export const NE = 'NE';
export const SE = 'SE';
export const SW = 'SW';
